<template id="MinhaLoja">
  <v-ons-page id="MinhaLojaPage">
    <v-card class="Card_Contain d-flex justify-center">
      <div class="Card_Titulo">
        <h1>Minha Loja</h1>
      </div>

      <div class="Container_Input" style="margin-top: 90px;">
        <v-row>
          <span>Nome:</span>
          <v-text-field outlined v-model="e.dsNome"></v-text-field>
        </v-row>

        <v-row>
          <span>Especialidade:</span>
          <v-select
            :items="arrEspecialidades"
            item-text="dsEspecialidade"
            item-value="idEspecialidade"
            v-model="e.idEspecialidade"
            outlined
          ></v-select>
        </v-row>

        <v-row>
          <v-col
            class="d-flex align-baseline"
            cols="8"
            style="padding: 0 !important"
          >
            <span>Endereço:</span>
            <v-text-field outlined v-model="e.dsEndereco"></v-text-field>
          </v-col>

          <v-col
            class="d-flex align-baseline"
            cols="4"
            style="padding: 0 !important"
          >
            <span
              style="
                margin-left: 15px !important;
                margin-right: 10px !important;
                min-width: 83px;"
              >Número:
              </span>
            <v-text-field
              type="number"
              id="numero"
              outlined
              v-model="e.vlEnderecoNumero"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            class="d-flex align-baseline"
            cols="8"
            style="padding: 0 !important"
          >
            <span>Bairro:</span>
            <v-text-field outlined v-model="e.dsBairro"></v-text-field>
          </v-col>

          <v-col
            class="d-flex align-baseline"
            cols="4"
            style="padding: 0 !important"
          >
            <span
              style="
                margin-left: 15px !important;
                margin-right: 10px !important;
                min-width: 83px;
              "
              >Estado:</span
            >
            <v-select
              :items="arrEstados"
              item-text="dsUF"
              item-value="idEstado"
              v-model="e.idEstado"
              @change="buscaCidades()"
              outlined
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <span>Cidade:</span>
          <v-select
            :items="arrCidades"
            item-text="dsNome"
            item-value="idCidade"
            v-model="e.idCidade"
            outlined
          ></v-select>
        </v-row>

        <v-row>
          <v-col
            class="d-flex align-baseline"
            cols="8"
            style="padding: 0 !important"
          >
            <span>Telefone:</span>
            <v-text-field outlined v-model="e.dsTelefone" v-mask="'(##) #####-####'"></v-text-field>
          </v-col>
        </v-row>
        
        <!-- Fazer o mask do email -->
        <v-row>
          <v-col
            class="d-flex align-baseline"
            cols="8"
            style="padding: 0 !important"
          >
            <span>Email:</span>
            <v-text-field outlined v-model="e.dsEmail" :rules="emailRules"></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="e.idVoucher == null" class="logo">
          <div class="container">
            <vue-dropzone
              ref="uploadLogo"
              :include-styling="false"
              :useCustomSlot="true"
              id="dropzone"
              :uploadMultiple="false"
              :options="dropzoneOptions"
              @vdropzone-file-added="uploadLogo"
            >
              <div class="dropzone-container align-center">
                <div class="file-selector d-flex align-items-center">
                  <p v-if="imgLogo == ''" class="textLogo">
                    Arraste ou clique para adicionar o seu logo
                  </p>
                  <img v-if="imgLogo != ''" :src="imgLogo" />
                  <v-ons-button type="button" class="botao" style="margin: 20px 0; max-height: 50px;">
                    <span v-show="imgLogo != ''">Mudar Logo</span>
                    <span v-show="imgLogo == ''">Procure aqui</span>
                  </v-ons-button>
                </div>
              </div>
            </vue-dropzone>
          </div>
        </v-row>

        <v-row v-if="e.idVoucher == null">
          <v-col class="temas">
            <span style="margin: 0;">Escolha seu tema:</span>
            <v-row style="margin-top: 20px;">
              <v-col>
                <v-ons-radio
                  @click="
                    () => {
                      e.dsCorLayout = 1;
                    }
                  "
                  name="dsCorLayout"
                  value="1"
                />
                <img src="../assets/img/cores-01.svg" />
              </v-col>
              <v-col>
                <v-ons-radio
                  @click="
                    () => {
                      e.dsCorLayout = 2;
                    }
                  "
                  name="dsCorLayout"
                  value="2"
                />
                <img src="../assets/img/cores-02.svg" />
              </v-col>
              <v-col>
                <v-ons-radio
                  @click="
                    () => {
                      e.dsCorLayout = 3;
                    }
                  "
                  name="dsCorLayout"
                  value="3"
                />
                <img src="../assets/img/cores-03.svg" />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-ons-radio
                  @click="
                    () => {
                      e.dsCorLayout = 4;
                    }
                  "
                  name="dsCorLayout"
                  value="4"
                />
                <img src="../assets/img/cores-04.svg" />
              </v-col>
              <v-col>
                <v-ons-radio
                  @click="
                    () => {
                      e.dsCorLayout = 5;
                    }
                  "
                  name="dsCorLayout"
                  value="5"
                />
                <img src="../assets/img/cores-05.svg" />
              </v-col>
              <v-col>
                <v-ons-radio
                  @click="
                    () => {
                      e.dsCorLayout = 6;
                    }
                  "
                  name="dsCorLayout"
                  value="6"
                />
                <img src="../assets/img/cores-06.svg" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="d-flex justify-center" style="margin-bottom: 30px">
          <v-ons-button class="botao" @click="salvarEstab()">Salvar</v-ons-button>
        </v-row>
      </div>
    </v-card>

    <h3 class="copy">Copyright © 2020. Todos os direitos reservados a Cyma Digital. <a class="copy" href="https://qrservice.com.br/termos-de-uso" target="_blank">Leia aqui os Termos e Condições.</a></h3>

  </v-ons-page>
</template>

<style scoped>
#MinhaLojaPage {
  margin-left: 256px !important;
}

.Container_Input .row {
  width: 55vw;
  min-height: 70px;
  display: flex;
  align-items: baseline;
}

.Container_Input span {
  margin-right: 20px;
  text-transform: none;
  font-size: 1.2rem;
  color: #4d4d4d;
  width: 128px;
  text-align: right;
}

#numero .v-input__slot {
  padding: 0px 5px;
}

ons-row {
  margin-top: 20px;
}
input,
ons-input,
ons-select {
  background-color: #fff;
  width: 40vw;
  border-radius: 5px;
  padding: 5px;
  margin-left: 30px;
  margin-right: 30px;
  font-size: 16px;
  height: 40px;
}
v-ons-label {
  width: 116px !important;
  display: inline-flex;
  justify-content: flex-end;
}
.text-input {
  color: gray;
}
.dropzone-container {
  display: flex;
  flex-direction: column;
  border: 1px dashed #ccc;
  border-radius: 15px;
}
.temas img {
  width: 50px;
}
.temas .radio-button {
  top: 35%;
  right: 10px;
}
.temas ons-col {
  border: 1px dashed lightgray;
  margin: 2px;
  padding: 0px;
  border-radius: 15px;
}
.temas ons-row {
  width: 70%;
  margin: auto;
}
.logo .container {
  width: 60%;
}
.logo img {
  max-width: 150px;
  max-height: 100px;
  object-fit: contain;
  margin-right: 20px;
}
.botao span {
  margin: 0 !important;
  color: #000;
  font-size: 1rem;
}
.copy {
  color: #666666;
  font-size: 0.8rem;
  font-family: "DMSans-Regular" !important;
  text-align: center;
  text-transform: none;
}
.topForm v-ons-label {
  width: 69% !important;
  float: left;
  justify-content: flex-start;
}
.textLogo {
  color: black;
  font-size: 12px;
  margin: auto;
  width: 175px;
}
.topForm ons-input,
.topForm ons-select {
  float: left;
  width: 69%;
  margin-left: 0px;
}
</style>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { isObject } from "util";

export default {
  name: "MinhaLoja",
  key: "MinhaLoja",
  props: ["pageStack"],
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      e: { dsNome: "", dsTelefone: "", dsEmail: "" },
      arrEspecialidades: [{ idEspecialidade: undefined, dsEspecialidade: "" }],
      arrEstados: [{ idEstado: undefined, dsEstado: "" }],
      arrCidades: [{ idCidade: undefined, dsNome: "" }],
      imgLogo: "",
      dropzoneOptions: {
        url: `${this.$menu_uri}/upload-image`,
        counter: 0,
        form: new FormData(),
        // File Size allowed in MB
        maxFilesize: 3000000,
        // The way you want to receive the files in the server
        paramName: function () {
          return "imgBytes";
        },
        dictDefaultMessage: "Adicione suas promoçōes",
        includeStyling: false,
        previewsContainer: false,
        thumbnailWidth: 250,
        thumbnailHeight: 140,
        uploadMultiple: false,
        parallelUploads: 1,
        manuallyAddFile: true,
        autoProcessQueue: false,
        acceptedFiles: "image/jpg,image/jpeg",
      },
      emailRules: [ 
        v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
    };
  },
  mounted() {
    var estab = localStorage.getItem("e");
    this.e = JSON.parse(estab);

    // this.e = this.$root.$children[0]._data.e;

    fetch(this.$menu_uri + "/minha-loja-base", { method: "GET" })
      .then((response) => response.json())
      .then((data) => {
        this.arrEspecialidades = data.especialidades;
        this.arrEstados = data.estados;
      });
    if (this.e.idEstado != "") {
      this.buscaCidades();
    }
    
    if (this.e.idVoucher == null) {
      if (this.e.dsCorLayout != null) { 
          document.querySelectorAll("ons-radio[name=dsCorLayout]")[
          parseInt(this.e.dsCorLayout) - 1
        ].checked = 1;
      }
      fetch(this.$menu_uri + "/logo/" + this.e.idEstabelecimento, { method: "GET" })
        .then((response) => response.json())
        .then((data) => {
          if (data[0] != undefined) {
            this.imgLogo = this.$menu_img_uri + data[0].dsImagem;
          }
        });
    }
    
  },
  methods: {
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return [parseFloat((bytes / Math.pow(k, i)).toFixed(dm)), sizes[i]];
    },
    uploadLogo(file) {
      // window.console.log(file)
      const fileSize = this.formatBytes(file.size);
      if (file.type !== "image/jpeg" || file.size > 3145728) {
        this.$ons.notification.toast(
          "Inserir somente imagens nas extensões: jpg, jpeg até 3MB, seu arquivo possui " +
            fileSize[0] +
            fileSize[1],
          { timeout: 4000, animation: "ascend" }
        );
        return;
      }

      let attachment = {};
      attachment.title = file.name.split(" ").join("").split(".").join("");
      attachment.extension = "." + file.type.split("/")[1];
      attachment.image = null;
      attachment.size = file.size;
      attachment.dsMedia = "imagem";
      attachment.show = false;
      attachment.dtComeca = null;
      attachment.dtTermina = null;
      attachment.menuComeca = false;
      attachment.menuTermina = false;

      const idEstabelecimento = this.e.idEstabelecimento;

      let formData = new FormData();
      let filename = attachment.title.replace(attachment.extension, "");
      if (attachment.extension === ".jpeg") {
        filename = attachment.title.replace(".jpg", "");
      }
      formData.append("imgBytes", file);
      formData.append("intImage", 0);
      formData.append("dsMedia", "imagem");
      formData.append("filename", filename);
      formData.append("idEstabelecimento", idEstabelecimento);
      fetch(this.$menu_uri + "/upload-image", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (isObject(data)) {
            attachment.image = this.$menu_img_uri + data.dsImagem;
            attachment.id = data.idCardapio;
            attachment.dtComeca = data.dtComeca;
            attachment.dtTermina = data.dtTermina;
            attachment.flSegunda = data.flSegunda === "0" ? false : true;
            attachment.flTerca = data.flTerca === "0" ? false : true;
            attachment.flQuarta = data.flQuarta === "0" ? false : true;
            attachment.flQuinta = data.flQuinta === "0" ? false : true;
            attachment.flSexta = data.flSexta === "0" ? false : true;
            attachment.flSabado = data.flSabado === "0" ? false : true;
            attachment.flDomingo = data.flDomingo === "0" ? false : true;
            attachment.dsTipo = data.dsTipo;
            attachment.dsMedia = data.dsMedia;

            if (data.dsTipo === "logo") {
              this.imgLogo = attachment.image;
            }
            this.$ons.notification.toast("Salvo com sucesso.", {
              timeout: 2000,
              animation: "ascend",
            });
          } else {
            this.$ons.notification.toast(
              "Ocorreu um erro ao salvar, tente novamente.",
              { timeout: 2000, animation: "ascend" }
            );
          }
        })
        .then((error) => {
          if (error) {
            this.$ons.notification.toast(
              "Ocorreu um erro ao salvar, tente novamente.",
              { timeout: 2000, animation: "ascend" }
            );
          }
        });
    },
    saveLocal() {
      localStorage.setItem("e", JSON.stringify(this.e));
    },
    buscaCidades() {
      fetch(this.$menu_uri + "/cidades/" + this.e.idEstado, { method: "GET" })
        .then((response) => response.json())
        .then((data) => {
          this.arrCidades = data;
        });
    },
    salvarEstab() {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(this.e.dsEmail)) {
        this.$ons.notification.toast("Por favor insira um EMAIL válido.", {
          timeout: 1000,
          animation: "ascend",
        });
      } else {
        fetch(this.$menu_uri + "/save-minha-loja", {
          method: "OPTIONS",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(this.e),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data === 1) {
              this.$ons.notification.toast(
                "Sua loja foi atualizada com sucesso.",
                { timeout: 1000, animation: "ascend" }
              );
              this.saveLocal();
            } else {
              this.$ons.notification.toast("Nenhuma alteração foi realizada.", {
                timeout: 1000,
                animation: "ascend",
              });
            }
          })
          .catch((error) => {
            if (error) {
              this.$ons.notification.toast(
                "Ocorreu um erro, por favor tente novamente.",
                { timeout: 1000, animation: "ascend" }
              );
            }
          });
      }
    },
  },
};
</script>